export let errorCodesDataCollectorDescription = "hitGHe";
export default {errorCodesDataCollectorDescription};